import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pagination"
}
const _hoisted_2 = { class: "pagination__circle pagination__circle--active" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "12", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "pagination"
}
const _hoisted_6 = { class: "pagination__circle pagination__circle--active" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.canShowPagination)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.currentStep !== 1)
              ? (_openBlock(), _createBlock(_component_Icon, {
                  key: 0,
                  "icon-name": "check",
                  class: "pagination__icon"
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass([_ctx.firstLineClasses, "pagination__divider"])
          }, null, 2),
          _createElementVNode("div", {
            class: _normalizeClass([_ctx.secondCircleClasses, "pagination__circle"])
          }, _hoisted_4, 2),
          _createElementVNode("div", {
            class: _normalizeClass(["pagination__divider", _ctx.secondLineClasses])
          }, null, 2),
          _createElementVNode("div", {
            class: _normalizeClass(["pagination__circle", _ctx.thirdCircleClasses])
          }, _toDisplayString(_ctx.steps), 3)
        ]))
      : _createCommentVNode("", true),
    (_ctx.canShowPagination)
      ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.currentStep !== 1)
              ? (_openBlock(), _createBlock(_component_Icon, {
                  key: 0,
                  "icon-name": "check",
                  class: "pagination__icon"
                }))
              : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.currentStep), 1))
          ]),
          _createElementVNode("div", {
            class: _normalizeClass([_ctx.firstLineClasses, "pagination__divider"])
          }, null, 2),
          _createElementVNode("div", {
            class: _normalizeClass([_ctx.secondCircleClasses, "pagination__circle"])
          }, [
            (_ctx.currentStep === 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, "2"))
              : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.currentStep), 1))
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["pagination__divider", _ctx.secondLineClasses])
          }, null, 2),
          _createElementVNode("div", {
            class: _normalizeClass(["pagination__circle", _ctx.thirdCircleClasses])
          }, _toDisplayString(_ctx.steps), 3)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}